import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-provider-product',
  templateUrl: './cloud-provider-product.component.html',
  styleUrls: ['./cloud-provider-product.component.scss']
})
export class CloudProviderProductComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
